import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class TransferaccountService {

  constructor(private dataService: DataService) { }

  getApplicationRefernceList() {
    return this.dataService.getRecord('/api/Application/getApplicationRefernceList');
  }

  savetransferaccount(transferaccountdetails: any) {
    return this.dataService.post('/api/Application/SaveTransferAccount', transferaccountdetails);
  }

  getUserTransferAccount() {
    return this.dataService.getRecord('/api/TransferAccount/getUserTransferAccountDetails');
  }

  getTransferAccount() {
    return this.dataService.getRecord('/api/TransferAccount/getTransferAccount');
  }

  getTransferAccountforApproval(applicationId: number) {
    return this.dataService.getRecord('/api/TransferAccount/getTransferAccountforApproval/' + applicationId);
  }

  getTransferAccountDetailsbyApplicationId(applicationId: number) {
    return this.dataService.getRecord('/api/TransferAccount/getTransferAccountDetailsbyApplicationId/' + applicationId);
  }
  getApplications(applicationReferenceNumber: string) {
    return this.dataService.getRecord(`/api/TransferAccount/getApplications?search=${applicationReferenceNumber}`)
  }
  getCustomerDetails(customerReferenceNumber: string) {
    return this.dataService.getRecord(`/api/TransferAccount/getTargetUsers?search=${customerReferenceNumber}`)
  }
  saveTransferAccount(payload : any)
  {
    return this.dataService.post('/api/TransferAccount/submitTransfer', payload)
  }
}
